import React, { ComponentProps, forwardRef } from 'react'

type Props = ComponentProps<'svg'>
const Logo = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <svg
    ref={ref}
    width="21"
    height="24"
    viewBox="0 0 21 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1_546)">
      <path
        d="M9.23405 14.4567V9.6875L8.93617 9.38942H4.17022L3.87234 9.6875V14.4567L4.17022 14.7548H8.93617L9.23405 14.4567Z"
        className="fill-[#181616] dark:fill-[#F5F3EF]"
      />
      <path
        d="M0.297872 15.9471L0 16.2452V19.0769L0.297872 19.375H3.12766L3.42553 19.0769V16.2452L3.12766 15.9471H0.297872Z"
        className="fill-[#181616] dark:fill-[#F5F3EF]"
      />
      <path
        d="M0.297872 4.76923L0 5.06731V7.89904L0.297872 8.19712H3.12766L3.42553 7.89904V5.06731L3.12766 4.76923H0.297872Z"
        className="fill-[#181616] dark:fill-[#F5F3EF]"
      />
      <path
        d="M20.8511 8.64423H15.4894L15.1915 8.34615V3.72596L14.8936 3.42788H10.1277L9.82978 3.12981V0.298076L9.53191 -9.53674e-07H6.25532L5.95744 0.298076V3.72596L6.25532 4.02404H9.82978L10.1277 4.32211V8.94231L10.4255 9.24038H15.4894L15.7872 9.53846V14.6058L15.4894 14.9038H10.4255L10.1277 15.2019V19.8221L9.82978 20.1202H6.25532L5.95744 20.4183V23.8462L6.25532 24.1442H9.53191L9.82978 23.8462V21.0144L10.1277 20.7163H14.8936L15.1915 20.4183V15.7981L15.4894 15.5H20.8511L21.1489 15.2019V8.94231L20.8511 8.64423Z"
        className="fill-[#181616] dark:fill-[#F5F3EF]"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_546">
        <rect width="21" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
))

Logo.displayName = 'Logo'

export default Logo
